import { listenerMiddleware, RootState } from '../store';
import { demoApi } from '../services/demoApi';

/**
 * Registers a `persist/REHYDRATE` listener that triggers the demo-summaries
 * fetch when a user returns to a page that was last in demo mode (the demo
 * flag is persisted with the rest of the demo slice). The non-demo summary
 * fetch lives in store.ts's inline rehydrate listener so a single mode-pick
 * doesn't need to be threaded through both files.
 */
const startDemoListeners = () => {
  listenerMiddleware.startListening({
    type: 'persist/REHYDRATE',
    effect: async (_, listenerApi) => {
      const state = listenerApi.getState() as RootState;
      if (state.demo?.isDemo !== true) return;
      listenerApi.dispatch(
        demoApi.endpoints.getDemoSubscriptionSummaries.initiate(),
      );
    },
  });
};

export default startDemoListeners;
